/*** Choose Diamond Function Start ***/
$(document).on("click", ".tps-choose-this-diamond", function(event) {

    // Stop link/button default action immediately
    event.preventDefault();
    event.stopPropagation();

    const $btn = $(this);
    $btn.addClass("tps-loading");

    var diamond_id = String($(this).data("id"));

    jQuery.getJSON('/cart.js', function(cart) {

        var diamondExists = false;

        $(cart.items).each(function(index, value) {

            var cartSku = value.sku || '';

            // Case 1: Diamond itself is in cart
            if (cartSku === diamond_id) {
                diamondExists = true;
                return false;
            }

            // Case 2: Diamond exists inside final ring SKU
            var skuParts = cartSku.split('-');

            if ($.inArray(diamond_id, skuParts) !== -1) {
                diamondExists = true;
                return false;
            }
        });

        $btn.removeClass("tps-loading");

        if (diamondExists) {

            alert(translations.titleDiamondProductAlreadyInCart);

            // DO NOT redirect / continue
            return false;
        }

        var diamond = [{
            "diamond_id": $btn.data("id"),
            "diamond_shape": $btn.data("shape"),
            "diamond_price": $btn.data("price"),
            "diamond_comprice": $btn.data("comprice"),
            "diamond_compare_formatted_price": $btn.data("compare-formatted-price"),
            "diamond_saving_price": $btn.data("saving-price"),
            "diamond_formatted_price": $btn.data("formatted-price"),
            "diamond_title": $btn.data("name"),
            "diamond_type": $btn.data("type"),
            "diamond_sub_type": $btn.data("sub-type"),
            "diamond_carat": $btn.data("carat"),
            "diamond_image": $btn.data("image"),
            "diamond_color": $btn.data("color"),
            "diamond_clarity": $btn.data("clarity"),
            "diamond_ratio": $btn.data("ratio"),
            "diamond_lwratio": $btn.data("lwratio")
        }];

        localStorage.setItem(
            "ring-selected-diamond",
            JSON.stringify(diamond)
        );

        setSteps("diamond");
    });
    
    // Important: return false from the click handler itself
    return false;
});
/*** Choose Diamond Function End ***/

/******* Choose Setting function start ******/
$(document).on("click", ".tps-choose-this-setting", function(e) { 
  e.preventDefault();
  $("#tps_choose_this_setting").addClass("tps-loading");
  var selected_diamond = localStorage.getItem("ring-selected-diamond");

  if(selected_diamond != null || selected_diamond != undefined){
    var ring_selected_shape = $("#setting_center_stone").val();
    selected_diamond = JSON.parse(selected_diamond);
    var diamond_shape = selected_diamond[0].diamond_shape;
    var diamond_title = selected_diamond[0].diamond_title;

    if(diamond_shape != ring_selected_shape){     
      alert(translations.titleSelectedRingSetting+""+diamond_title+""+translations.titleChangeYourDiamondOrRing);     
      
      $("#tps_choose_this_setting").removeClass("tps-loading");
      return false;
    }    
  }

  var currency_rate = Shopify.currency.rate;
  currency_rate = parseFloat(currency_rate);
  var product_id = $("#product_id").val();
  var product_price = $("#setting_price").val()/100;
  var product_price_in_base_currency = product_price/currency_rate;
  product_price_in_base_currency = Math.floor(product_price_in_base_currency.toFixed(2));

  var product_comp_price = $("#setting_compare_price").val()/100;
  var product_comp_price_in_base_currency = product_comp_price/currency_rate;
  product_comp_price_in_base_currency = Math.floor(product_comp_price_in_base_currency.toFixed(2));
 
  var setting_metafields = {};
  try {
    setting_metafields = JSON.parse($("#setting_metafields_data").val() || "{}");
  } catch (e) {
    setting_metafields = {};
  }

  // Fallback / supplement: pull side-stone (and center-stone) fields straight
  // from the rendered description block if they weren't captured above.
  var domFieldKeys = [
    'setting_metal', 'ring_width',
    'center_stone_diamond', 'center_stone_shape', 'center_stone_weight',
    'center_stone_color', 'center_stone_clarity', 'center_stone_clarification', 'center_stone_setting',
    'side_stone_diamond', 'side_stone_shape', 'side_stone_weight',
    'side_stone_color', 'side_stone_clarity', 'side_diamond_certification', 'side_stone_setting'
  ];

  domFieldKeys.forEach(function(key) {
    if (setting_metafields[key] === undefined || setting_metafields[key] === null || setting_metafields[key].toString().trim() === '') {
      var domVal = $('#tps_' + key).text().trim();
      if (domVal !== '') {
        setting_metafields[key] = domVal;
      }
    }
  });

  var setting = [{
      "product_id": $("#product_id").val(),
      "product_handle": $("#product_handle").val(),
      "product_title": $("#product_title").val(),
      "product_description": $(".tps-product-description").html(),
      "product_url": $("#product_url").val(),
      "setting_id": $("#setting_id").val(),
      "setting_sku": $("#setting_sku").val(),
      "setting_price": product_price_in_base_currency,
      "setting_comp_price": product_comp_price_in_base_currency,
      "setting_formatted_price": $("#setting_formatted_price").val(),    
      "setting_metal": $("#setting_metal").val(),
      "setting_center_stone": $("#setting_center_stone").val(),
      "setting_can_be_match_with": $("#setting_can_be_match_with").val(),
      "setting_image": $("#setting_image").val(),
      "setting_description": $("#setting_description").val(),
      "setting_ring_size": $("#setting_ring_size").val(),
      "setting_stone_type": $("#setting_stone_type").val(),
      "setting_metafields": setting_metafields,
  }];
  localStorage.setItem("ring-selected-product-id", product_id);
  localStorage.setItem("ring-selected-setting", JSON.stringify(setting));
  $("#tps_choose_this_setting").removeClass("tps-loading");
  setSteps("setting");
});

/*** Set Currenct Step And Redirect To Next Step Start ****/
function setSteps(current_step) {
    var setp1 = "diamond";
    var setp2 = "setting";
    var setp3 = "final-ring";
  
    var ring_selected_diamond = localStorage.getItem("ring-selected-diamond"); 
    var ring_selected_setting = localStorage.getItem("ring-selected-setting"); 

    var diamond_info = JSON.parse(ring_selected_diamond);
    var setting_info = JSON.parse(ring_selected_setting);
  
    if (ring_selected_setting && ring_selected_diamond) {
        var setp3 = "final-ring";        
        
      	var diamond_price = (diamond_info[0].diamond_price);      	    
        var final_price = parseInt(setting_info[0].setting_price/100) + diamond_price; 
        
        var diamond_id = diamond_info[0].diamond_id;
        var setting_id = setting_info[0].product_handle;
        var varient_id = setting_info[0].setting_id;        
        var diamond_sub_type = diamond_info[0].diamond_sub_type;
        if(diamond_sub_type == 'fancy'){
          var diamond_type = 'lab-fancy';  
        }else{
          var diamond_type = 'lab-white';  
        }
        window.location.href = tps_config.urls.final_ring+"?products="+diamond_id+"/"+setting_id+"/"+varient_id+"/"+diamond_type; // "/pages/final-pendant";

    } else if (current_step == "diamond" && ring_selected_setting) {
        var setp2 = "diamond";
        window.location.href = tps_config.urls.final_ring; // "/pages/final-ring"; 
    } else if (current_step == "setting" && ring_selected_diamond) {
        var setp2 = "setting";
        window.location.href = tps_config.urls.final_ring; //"/pages/final-ring"; 
    } else if (current_step == "diamond" && !ring_selected_setting) {
        var setp1 = "diamond";
        var setp2 = "setting";

        window.location.href = tps_config.urls.setting_listing;
    } else if (current_step == "setting" && !ring_selected_diamond) {
      	var setp1 = "setting";
        var setp2 = "diamond";
        var setting_diamond_type = setting_info[0].setting_stone_type;
        if(setting_diamond_type == 'Natural'){
          window.location.href = tps_config.urls.loose_diamond;
        } else {
          window.location.href = tps_config.urls.lab_diamond;
        }
        
    }

    var steps = [{
      "step1": setp1,
      "step2": setp2,
      "step3": setp3,
    }];
    var session_steps = localStorage.getItem("ringbuilder-steps");
    if(session_steps == null){
      localStorage.setItem("ringbuilder-steps", JSON.stringify(steps));
    }
}
/*** Set Currenct Step And Redirect To Next Step End ****/

$(document).ready(function() {         
      /*** set last updated timestamp of product collection if local storage has 1 hour old product collection then clear collection ****/
      if (localStorage.getItem("ringbuilder-last-updated")) {
          var d1 = new Date();
          var d2 = new Date(localStorage.getItem("ringbuilder-last-updated"));
          var diff = parseInt(((d1 - d2) / 1000).toString());
          if (diff > 3600) {
              localStorage.clear();
              localStorage.setItem("ringbuilder-last-updated", d1);
          }
      } else {
          localStorage.setItem("ringbuilder-last-updated", new Date());
      }

      /**** set steps and render steps data start *****/
      var active = '';      
      var session_steps = localStorage.getItem("ringbuilder-steps");           
      if(session_steps == null){        
        if((window.location.pathname.indexOf('/products/') == 0 || window.location.pathname.indexOf('/collections/') == 0)){
            active = "setting";              
            changeStepFlow();            
        }else if(window.location.pathname.indexOf('/pages/') == 0){   
            active = "diamond";  
        }        
      }else if(session_steps != null){        
        session_steps = JSON.parse(session_steps);
        if (window.location.pathname.indexOf('final-engagement-ring') > -1) {
            active = "final"; 
            setStepDetails(active);
            if(session_steps[0]['step1'] == "setting"){
              changeStepFlow();
            }   
        }else if(session_steps[0]['step1'] == "diamond"){            
            if(window.location.pathname.indexOf('/pages/') == 0){
              active = "diamond";
            }else if (window.location.pathname.indexOf('/products/') == 0 || window.location.pathname.indexOf('/collections/') == 0) {
              active = "setting";
            }            
            setStepDetails(active);
        }else if(session_steps[0]['step1'] == "setting"){
            if(window.location.pathname.indexOf('/pages/') == 0){
              active = "diamond";
            }else if (window.location.pathname.indexOf('/products/') == 0 || window.location.pathname.indexOf('/collections/') == 0) {
              active = "setting";
            }            
            changeStepFlow();
            setStepDetails(active);
        }
      }

      setTimeout(function() {
        $(".tps-step-icon").removeClass('tps-step-icon-loader');
      }, 150);
  });
/**** set steps and render steps data end *****/

/*** Change Steps For Start With Setting Slow Start ***/
function changeStepFlow() {   
  $(".tps-step-block-1 .tps-step-icon").removeClass('tps-step-icon-diamond').addClass('tps-step-icon-setting');
  $(".tps-step-block-2 .tps-step-icon").removeClass('tps-step-icon-setting').addClass('tps-step-icon-diamond');
  $(".tps-step-icon").removeClass('tps-step-icon-loader');
 
  $(".tps-step-block-1 .tps-step-title .tps-step-title-section2").html(translations.titleSetting);
  $(".tps-step-block-2 .tps-step-title .tps-step-title-section2").html(translations.titleStone);

  $(".tps-step-block-1 .tps-step-link-url").html(translations.titleBrowseSettings);
  $(".tps-step-block-2 .tps-step-link-url").html(translations.titleBrowseStones);

  $(".tps-step-block-1 .tps-step-link-url").attr('href',tps_config.urls.setting_listing);
  $(".tps-step-block-2 .tps-step-link-url").attr('href',tps_config.urls.lab_diamond);     
}
/*** Change Steps For Start With Setting Slow End ***/

/*** Set Selected Product Info In Steps Start ***/
function setStepDetails(active) {
  var currency_rate = Shopify.currency.rate;
  var session_steps = localStorage.getItem("ringbuilder-steps");
  session_steps = JSON.parse(session_steps);
  
  var ring_selected_diamond = localStorage.getItem("ring-selected-diamond"); 
  var ring_selected_setting = localStorage.getItem("ring-selected-setting");   
  var diamond_info = JSON.parse(ring_selected_diamond);
  var setting_info = JSON.parse(ring_selected_setting); 
  
  if(active == 'diamond' && session_steps[0]['step2'] == 'diamond'){  
    $(".tps-step-block").removeClass('current-active');
    $(".tps-step-block-2").addClass('active');
    $(".tps-step-block-2").addClass('current-active');
  }else if(active == 'setting' && session_steps[0]['step2'] == 'setting'){ 
    $(".tps-step-block-2").addClass('active');
  }
   
  if(ring_selected_diamond){
    if(session_steps[0]['step1'] == 'diamond'){
      var step_position = '1';
    }else if(session_steps[0]['step2'] == 'diamond'){
      var step_position = '2';
    }
    
    var product_id = diamond_info[0].diamond_id;
    var product_price = getDiamondPrice(currency_rate,diamond_info[0].diamond_price);    
    var product_url = tps_config.urls.loose_diamond_detail+'?diamond_id='+product_id+'&diamond_type='+diamond_info[0].diamond_type;
    var product_image = diamond_info[0].diamond_image;
    var product_title = diamond_info[0].diamond_title;  

    var stepProductInfoHtml = getStepsProductHtmlLayout('diamond',product_title,product_price,product_image,product_url);
    $(".tps-step-block-"+step_position+" .tps-step-product-info").html(stepProductInfoHtml);

    var stepsProductChange = '<a href="'+product_url+'" alt="'+product_title+'" title="'+product_title+'">'+translations.titleChange+'</a>';
    $(".tps-step-block-"+step_position+" .tps-step-product-change-info").html(stepsProductChange);

    $(".tps-step-block-"+step_position+" .tps-step-link-url").remove(); //remove browse url
    $(".tps-step-block-"+step_position+" .tps-"+step_position+"-step-icon").hide(); //remove icon
  }
 
  if(ring_selected_setting){
    if(session_steps[0]['step1'] == 'setting'){
      var step_position = '1';
    }else if(session_steps[0]['step2'] == 'setting'){
      var step_position = '2';
    }
    var product_id = setting_info[0].product_id;
    var product_price = getDiamondPrice(currency_rate,setting_info[0].setting_price);    
    var product_url = setting_info[0].product_url;
    var product_image = setting_info[0].setting_image;
    var product_title = setting_info[0].product_title;  

    var stepProductInfoHtml = getStepsProductHtmlLayout('setting',product_title,product_price,product_image,product_url);
    $(".tps-step-block-"+step_position+" .tps-step-product-info").html(stepProductInfoHtml);

    var stepsProductChange = '<a href="'+product_url+'" alt="'+product_title+'" title="'+product_title+'">'+translations.titleChange+'</a>';
    $(".tps-step-block-"+step_position+" .tps-step-product-change-info").html(stepsProductChange);

    $(".tps-step-block-"+step_position+" .tps-step-link-url").remove(); //remove browse url
    $(".tps-step-block-"+step_position+" .tps-"+step_position+"-step-icon").hide(); //remove icon
  }
  
  if(ring_selected_setting && ring_selected_diamond) {   
    $(".tps-step-block").addClass('active');
    if(active == 'final'){
      $(".tps-step-block").removeClass('current-active');
      $(".tps-step-block-3").addClass('current-active');
    }
    

    var product_price = getFinalProductPrice();
    var diamond_id = diamond_info[0].diamond_id;
    var product_handle = setting_info[0].product_handle;
    var setting_id = setting_info[0].setting_id;
    var diamond_type = diamond_info[0].diamond_type;
    var product_url = tps_config.urls.final_ring+'?setting_select=true&diamond_select=true?products='+diamond_id+'/'+product_handle+'/'+setting_id+'/'+diamond_type;
    var product_image = setting_info[0].setting_image;
    var product_title = setting_info[0].product_title+" With "+diamond_info[0].diamond_title;

    var stepProductInfoHtml = getStepsProductHtmlLayout('final',product_title,product_price,product_image,product_url);
    $(".tps-step-block-3 .tps-step-product-info").html(stepProductInfoHtml);

    var stepsProductChange = '<span onclick="resetRing(`'+session_steps[0]['step1']+'`);">'+translations.titleReset+'</span>';
    $(".tps-step-block-3 .tps-step-product-change-info").html(stepsProductChange);

    $(".tps-step-block-3 .tps-3-step-icon").hide(); //remove icon
  }
}
/*** Set Selected Product Info In Steps End ***/

/*** Get Steps Product View Layout Start ***/
function getStepsProductHtmlLayout(action,product_title,product_price,product_image,product_url) {
  var session_steps = localStorage.getItem("ringbuilder-steps");
  session_steps = JSON.parse(session_steps);
  
  var stepProductInfoHtml = '';
  stepProductInfoHtml += '<div class="tps-step-block-steps-info-wrapper">';
  stepProductInfoHtml += '<div class=tps-step-block-steps-info-content>';
  stepProductInfoHtml += '<span class="tps-step-block-steps-info-title">'+product_title+'</span>';
  stepProductInfoHtml += '<div class="tps-step-more-sec">';
  stepProductInfoHtml += '<span class="tps-step-block-steps-info-view-remove">';
  if(action == 'diamond' || action == 'setting'){
    stepProductInfoHtml += '<a href="javascript:void(0);" rel="nofollow" class="tps-step-view-popup-link" onclick="openStepInfoPopup(\''+action+'\');return false;">'+translations.titleView+'</a>';
  }else{
    stepProductInfoHtml += '<a href="'+product_url+'" rel="nofollow" class="">'+translations.titleView+'</a>';
  }
  if(action == 'final'){
    stepProductInfoHtml += '<span class="" onclick="resetRing(`'+session_steps[0]['step1']+'`);">'+translations.titleReset+'</span>';
  }else{
    stepProductInfoHtml += '<span class="" onclick="removeProduct(`'+action+'`);">'+translations.titleChange+'</span>';
  }  
  
  stepProductInfoHtml += '</span>';
  stepProductInfoHtml += '<span class="tps-step-block-steps-info-price">'+product_price+'</span>';
  stepProductInfoHtml += '</div>';
  stepProductInfoHtml += '</div>';
  stepProductInfoHtml += '<div class="tps-step-block-steps-info-img">';
  stepProductInfoHtml += '<img src="'+product_image+'" title="'+product_title+'" alt="'+product_title+'">';
  stepProductInfoHtml += '</div>';
  stepProductInfoHtml += '</div>';
  return stepProductInfoHtml;
}
/*** Get Steps Product View Layout End ***/

/*** Step Info Popup (View) Start ***/
var tpsStepPopupOverlay = null;
var tpsStepPopupContent = null;
var tpsStepPopupBox = null;

/* Builds the popup DOM once and injects it into the page (same pattern used for the ring try-on popup) */
function ensureStepInfoPopup() {
  if (tpsStepPopupOverlay) { return; }

  tpsStepPopupOverlay = document.createElement('div');
  tpsStepPopupOverlay.className = 'tps-step-info-popup-overlay';

  var box = document.createElement('div');
  box.className = 'tps-step-info-popup-box';
  tpsStepPopupBox = box;

  var closeBtn = document.createElement('span');
  closeBtn.className = 'tps-step-info-popup-close';
  closeBtn.innerHTML = '&times;';
  closeBtn.onclick = closeStepInfoPopup;

  tpsStepPopupContent = document.createElement('div');
  tpsStepPopupContent.className = 'tps-step-info-popup-content';

  box.appendChild(closeBtn);
  box.appendChild(tpsStepPopupContent);
  tpsStepPopupOverlay.appendChild(box);
  document.body.appendChild(tpsStepPopupOverlay);

  tpsStepPopupOverlay.addEventListener('click', function (e) {
    if (e.target === tpsStepPopupOverlay) {
      closeStepInfoPopup();
    }
  });

}

function showStepInfoPopup(html, type) {
  ensureStepInfoPopup();
  tpsStepPopupContent.innerHTML = html;

  // Differentiate the diamond popup from the setting popup with a modifier class
  // (e.g. "tps-step-info-popup-box--diamond" / "tps-step-info-popup-box--setting")
  tpsStepPopupBox.classList.remove('tps-step-info-popup-box--diamond', 'tps-step-info-popup-box--setting');
  if (type) {
    tpsStepPopupBox.classList.add('tps-step-info-popup-box--' + type);
  }

  tpsStepPopupOverlay.classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeStepInfoPopup() {
  if (tpsStepPopupOverlay) {
    tpsStepPopupOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }
}

/* Generic markup builder shared by both the diamond and the setting popup.
   Pass either:
     - data.sections: [{ heading: 'Product Details', rows: [[{label,value}, ...], ...] }, ...]
   or the older single-section shorthand:
     - data.infoHeading + data.rows */
function buildStepInfoPopupHtml(data) {  
  var html = '';
  html += '<div class="tps-step-info-popup-image"><img src="' + data.image + '" alt="' + data.title + '"></div>';
  html += '<div class="tps-step-info-popup-body">';
    html += '<div class="tps-step-info-popup-title-price">';
    html += '<div class="tps-step-info-popup-title">' + data.title + '</div>';
    html += '<div class="tps-step-info-popup-price">' + data.price;
    if (data.comparePrice) {
      html += '<del>' + data.comparePrice + '</del><span id="savePrice">Save ' + data.differentPrice + '</span>';
    }
    html += '</div>';
  html += '</div>';


  var sections = (data.sections && data.sections.length) ? data.sections : [{ heading: data.infoHeading, rows: data.rows || [] }];

  if(sections){
    html += '<div class="tps-step-info-popup-sections">';
    sections.forEach(function (section) {
      if (!section.rows || !section.rows.length) { return; } // skip empty sections entirely (e.g. no side stone data)

      if(section.heading != "Center Stone Details"){
        html += '<div class="tps-step-info-popup-heading">' + section.heading + '</div>';
        html += '<div class="tps-step-info-popup-grid">';
        section.rows.forEach(function (row) {
          html += '<div class="tps-step-info-popup-row">';
          row.forEach(function (cell) {
            html += '<div class="tps-step-info-popup-cell">';
            html += '<span class="tps-step-info-popup-label">' + cell.label + '</span>';
            html += '<span class="tps-step-info-popup-value">' + (cell.value ? cell.value : '-') + '</span>';
            html += '</div>';
          });
          html += '</div>';
        });
        html += '</div>';
      }
    });
    html += '</div>';
  }

  html += '<div class="tps-step-info-popup-actions">';
  html += '<a href="' + data.product_url + '" class="tps-step-info-popup-btn">' + translations.titleView + '/' + translations.titleEdit + '</a>';
  html += '<span class="tps-step-info-popup-btn" onclick="removeProduct(\'' + data.removeAction + '\');closeStepInfoPopup();">' + translations.titleChange + '</span>';
  html += '</div>';
  html += '</div>';
  return html;
}

/*** Setting View Popup - Field Configuration ***
 * Controls what shows up in each section of the "View" popup for a selected setting,
 * in what order, and under what label. To customize:
 *   - Change "label" to whatever text you want the customer to see.
 *   - Add/remove/reorder {key, label} entries within a section's "fields" array.
 *   - "source: fixed" pulls straight from the setting object saved to localStorage
 *     (setting_sku / setting_metal). Everything else pulls from
 *     setting_info[0].setting_metafields[key] (product + variant metafields captured
 *     at selection time - see updateSettingMetafieldsData() in tps-setting-product.liquid).
 *   - A field is automatically left out if it has no value for the chosen setting.
 *   - A whole section (heading included) is left out if none of its fields have a value.
 *   - This is a function (not a plain array) so that "translations" is only read when the
 *     popup actually opens - reading it any earlier, at page-load time, throws a
 *     ReferenceError if the translations snippet hasn't rendered yet.
 */
function getSettingPopupSections() {
  return [
    {
      heading: translations.titleProductDetails ? translations.titleProductDetails : 'Product Details',
      fields: [        
        { key: 'setting_metal', label: translations.titleMetalType ? translations.titleMetalType : 'Metal Type', source: 'fixed' },
        { key: 'setting_sku', label: 'SKU', source: 'fixed' },
        { key: 'ring_width', label: 'Width' }
      ]
    },
    {
      heading: 'Center Stone Details',
      fields: [
        { key: 'center_stone_diamond', label: 'Diamond Type' },
        { key: 'center_stone_shape', label: 'Shape' },
        { key: 'center_stone_weight', label: 'Approximate Carat Weight' },
        { key: 'center_stone_color', label: 'Average Color' },
        { key: 'center_stone_clarity', label: 'Average Clarity' },
        { key: 'center_stone_clarification', label: 'Certification' },
        { key: 'center_stone_setting', label: 'Setting' }
      ]
    },
    {
      heading: 'Side Stone Details',
      fields: [
        { key: 'side_stone_diamond', label: 'Diamond Type' },
        { key: 'side_stone_shape', label: 'Shape' },
        { key: 'side_stone_weight', label: 'Approximate Carat Weight' },
        { key: 'side_stone_color', label: 'Average Color' },
        { key: 'side_stone_clarity', label: 'Average Clarity' },
        { key: 'side_diamond_certification', label: 'Certification' },
        { key: 'side_stone_setting', label: 'Setting' }
      ]
    }
  ];
}

/* Looks up a single field's value: "fixed" fields come straight off the setting object,
   everything else comes from the captured setting_metafields. */
function getSettingFieldValue(fieldConfig, setting_info) {
  if (fieldConfig.source === 'fixed') {
    return setting_info[0][fieldConfig.key];
  }
  var metafields = setting_info[0].setting_metafields || {};
  return metafields[fieldConfig.key];
}

/* Turns getSettingPopupSections() + the stored setting_info into the {heading, rows} sections
   buildStepInfoPopupHtml expects, dropping blank fields and empty sections along the way. */
function buildSettingPopupSections(setting_info) {
  var sections = [];

  getSettingPopupSections().forEach(function (sectionConfig) {
    var rows = [];
    var pair = [];

    sectionConfig.fields.forEach(function (fieldConfig) {
      var value = getSettingFieldValue(fieldConfig, setting_info);
      if (value === null || value === undefined || value.toString().trim() === '') { return; }

      pair.push({ label: fieldConfig.label, value: value });
      if (pair.length === 2) {
        rows.push(pair);
        pair = [];
      }
    });
    if (pair.length) { rows.push(pair); }

    if (rows.length) {
      sections.push({ heading: sectionConfig.heading, rows: rows });
    }
  });

  return sections;
}

/* Reads the currently selected diamond/setting from localStorage and opens the matching popup.
   NOTE: Setting product + variant metafields (color/clarity/ratio/width/side-stone details, etc.)
   are captured at selection time into setting_info[0].setting_metafields and rendered dynamically
   via getSettingPopupSections() above. Diamond fields (color/clarity/ratio/L-W mm) are not yet captured
   into localStorage since diamonds aren't Shopify products/variants with metafields - add extra
   {label, value} cells to the diamond "rows" array below if/when that data becomes available. */
function openStepInfoPopup(action) {
  var currency_rate = Shopify.currency.rate;

  if (action == 'diamond') {
    var diamond_info = JSON.parse(localStorage.getItem("ring-selected-diamond"));
    if (!diamond_info) { return; }

    var product_price = getDiamondPrice(currency_rate, diamond_info[0].diamond_price);
    var product_url = tps_config.urls.loose_diamond_detail + '?diamond_id=' + diamond_info[0].diamond_id + '&diamond_type=' + diamond_info[0].diamond_type;

    var html = buildStepInfoPopupHtml({
      title: diamond_info[0].diamond_title,
      price: product_price,
      comparePrice: diamond_info[0].diamond_compare_formatted_price,
      differentPrice:  diamond_info[0].diamond_saving_price,
      image: diamond_info[0].diamond_image,
      infoHeading: translations.titleYourDiamondInfo ? translations.titleYourDiamondInfo : 'Your Diamond Info',
      rows: [
        [
          { label: translations.titleShape ? translations.titleShape : 'Shape', value: diamond_info[0].diamond_shape },
          { label: translations.titleCaratWeight ? translations.titleCaratWeight : 'Carat Weight', value: diamond_info[0].diamond_carat },
          { label: translations.titleColor ? translations.titleColor : 'Color', value: diamond_info[0].diamond_color },
          { label: translations.titleClarity ? translations.titleClarity : 'Clarity', value: diamond_info[0].diamond_clarity },
          { label: translations.titleRatio ? translations.titleRatio : 'Ratio', value: diamond_info[0].diamond_ratio },
          { label: translations.titlelw ? translations.titlelw : 'L/W (mm)', value: diamond_info[0].diamond_lwratio },
        ]
      ],
      product_url: product_url,
      removeAction: 'diamond'
    });

    showStepInfoPopup(html, 'diamond');

  } else if (action == 'setting') {
    var setting_info = JSON.parse(localStorage.getItem("ring-selected-setting"));
    if (!setting_info) { return; }

   

    var product_price = getDiamondPrice(currency_rate, setting_info[0].setting_price);

    var rawPrice = Number(setting_info[0].setting_price);
    var rawComparePrice = Number(setting_info[0].setting_comp_price);
    var hasComparePrice = !isNaN(rawComparePrice) && rawComparePrice > rawPrice;

    var comparePrice = hasComparePrice ? getDiamondPrice(currency_rate, rawComparePrice) : '';
    var differPrice = hasComparePrice ? getDiamondPrice(currency_rate, rawComparePrice - rawPrice) : '';

    var product_url = setting_info[0].product_url;

    var html = buildStepInfoPopupHtml({
      title: setting_info[0].product_title,
      price: product_price,
      comparePrice: comparePrice,
      differentPrice: differPrice,
      image: setting_info[0].setting_image,
      sections: buildSettingPopupSections(setting_info),
      product_url: product_url,
      removeAction: 'setting'
    });

    showStepInfoPopup(html, 'setting');
  }
}

/*** Step Info Popup (View) End ***/

/*** Remove Product From RingBuilder Flow Start ***/
function removeProduct(action) {
  localStorage.removeItem("ring-selected-"+action);
  if(action == 'setting'){
      window.location.href = tps_config.urls.setting_listing+"";
  }else{
      window.location.href = tps_config.urls.lab_diamond+"";
  }
}
/*** Remove Product From RingBuilder Flow End ***/

/**** Ring Builder Flow Reset Start *****/
function resetRing(step){
  let message = translations.titleResetRing;
  if (confirm(message) == true) {
    localStorage.clear();  
    if(step == 'setting'){
        window.location.href = tps_config.urls.setting_listing+"";
    }else{
        window.location.href = tps_config.urls.lab_diamond+"";
    }
  } else {
    return false;
  } 
}
/**** Ring Builder Flow Reset End *****/

/**** steps progress bar actve  *************/
$(document).ready(function() {
  setWidthToStepProgressBar();
  function setWidthToStepProgressBar() {
      var stepDiv = jQuery('.tps-ringbuilder-steps');
      var pgBar = stepDiv.find('.tps-steps-bg-progress-bar');
      var stepBlockSecond = stepDiv.find('.tps-step-block-2');
      var stepBlockThird = stepDiv.find('.tps-step-block-3');
      if (stepBlockSecond.hasClass('active') && !stepBlockThird.hasClass('active')) {
        pgBar.css('width', '35%');
      } else if(stepBlockThird.hasClass('active')) {
        pgBar.css('width', '70%');
      }
    }  
});